export const AccordionHeaderParamsTexts = {
  HeaderDefaultTitle: 'Цель кредита',
  HeaderDefaultDescription: 'Заполните данные',
};
